import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function NotFound() {
  const { t } = useTranslation()
  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={6} className="text-center">
          <h1 className="display-1" style={{ color: 'var(--color-primary)' }}>404</h1>
          <h2 style={{ color: 'var(--color-primary-dark)' }}>{t('not_found.title')}</h2>
          <p className="text-secondary mb-4">
            {t('not_found.message')}
          </p>
          <Button
            as={Link}
            to="/"
            style={{
              backgroundColor: 'var(--color-primary)',
              borderColor: 'var(--color-primary)',
              fontWeight: 500
            }}
          >
            {t('not_found.go_dashboard')}
          </Button>
        </Col>
      </Row>
    </Container>
  )
}

export default NotFound
